const passengers = {
  table: {
    headers: {
      name: 'Nombre',
      email: 'Correo electrónico',
      created: 'Fecha de creación',
      id: 'ID',
      profiles: 'Perfiles asociados',
      createdBy: 'Creado por',
      baseAddress: 'Dirección de domicilio',
      occupationAddress: 'Dirección de trabajo',
      createdAt: 'Creado en',
      profile: 'Perfil',
    },
  },
};

export default passengers;
